import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://www.citytrafikskolauppsala.se";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    selector.match(/\[(.+?)="(.+?)"\]/g)?.forEach((m) => {
      const [, k, v] = m.match(/\[(.+?)="(.+?)"\]/);
      el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export default function useSeo({ title, description }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const fullTitle = title ? `${title} | City Trafikskola Uppsala` : "City Trafikskola Uppsala | Din väg till körkortet";
    const url = `${SITE}${pathname === "/" ? "/" : pathname}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
  }, [title, description, pathname]);
}
